import React from 'react';
import {Box, IconButton, Stack, Tooltip, Typography} from '@mui/material';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import {DatePicker} from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import RefreshIcon from '@mui/icons-material/Refresh';

/**
 * Baseline date + refresh for cluster-first delta (no entity list).
 */
export default function DeltaClusterControls({
    isProductLoading,
    clustersLoading,
    baselineDate,
    onBaselineDateChange,
    daysSinceBaseline,
    onRefreshDeltaRun,
    refreshDisabled = false,
    heading = 'Report delta clusters',
    description = 'Changes since the baseline vs claims in this report, ranked by significance.',
}) {
    return (
        <Stack spacing={2} sx={{py: 2}}>
            <Box
                sx={{
                    px: 2,
                    display: 'flex',
                    alignItems: 'flex-start',
                    justifyContent: 'space-between',
                    gap: 1,
                }}
            >
                <Box sx={{minWidth: 0}}>
                    <Typography variant="subtitle1" fontWeight={600}>
                        {heading}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        {description}
                        {daysSinceBaseline != null ? ` ${daysSinceBaseline} days since selected date.` : ''}
                    </Typography>
                </Box>
                {onRefreshDeltaRun ? (
                    <Tooltip title="New delta run (separate LLM audit)">
                        <span>
                            <IconButton
                                size="small"
                                onClick={onRefreshDeltaRun}
                                disabled={refreshDisabled || isProductLoading || clustersLoading}
                                aria-label="New delta run"
                            >
                                <RefreshIcon fontSize="small"/>
                            </IconButton>
                        </span>
                    </Tooltip>
                ) : null}
            </Box>

            <Box sx={{px: 2}}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                        label="Delta baseline date"
                        value={baselineDate ? dayjs(baselineDate) : null}
                        onChange={(newValue) => {
                            onBaselineDateChange(newValue && newValue.isValid() ? newValue.toDate() : null);
                        }}
                        slotProps={{
                            textField: {
                                size: 'small',
                                fullWidth: true,
                            },
                        }}
                    />
                </LocalizationProvider>
            </Box>
        </Stack>
    );
}
